import { useEffect, useState } from 'react';

const GEO_LOOKUP_ENDPOINT = 'https://ipwho.is/';
const GEO_LOOKUP_TIMEOUT_MS = 4000;

const normalizeIpCountry = (payload) => {
	if (!payload || payload.success === false) return null;

	const countryIso = String(payload.country_code || '')
		.trim()
		.toLowerCase();
	const dialCode = String(payload.calling_code || '').replace(/\D/g, '');

	if (!countryIso) return null;

	return {
		countryIso,
		dialCode,
	};
};

const useIpCountry = () => {
	const [ipCountry, setIpCountry] = useState({
		countryIso: '',
		dialCode: '',
	});

	useEffect(() => {
		const controller = new AbortController();
		const timeoutId = window.setTimeout(() => controller.abort(), GEO_LOOKUP_TIMEOUT_MS);

		const resolveIpCountry = async () => {
			try {
				const response = await fetch(GEO_LOOKUP_ENDPOINT, {
					signal: controller.signal,
				});

				if (!response.ok) {
					throw new Error(`IP country lookup failed with status ${response.status}`);
				}

				const payload = await response.json();
				const normalizedCountry = normalizeIpCountry(payload);

				if (normalizedCountry) {
					setIpCountry(normalizedCountry);
				}
			} catch (error) {
				if (error?.name !== 'AbortError') {
					setIpCountry({
						countryIso: '',
						dialCode: '',
					});
				}
			} finally {
				window.clearTimeout(timeoutId);
			}
		};

		resolveIpCountry();

		return () => {
			controller.abort();
			window.clearTimeout(timeoutId);
		};
	}, []);

	return ipCountry;
};

export default useIpCountry;
